import prodConfig from "./config.prod.json";
import devConfig from "./config.dev.json";
import stagingConfig from "./config.staging.json";
import baseConfig from "./config.base.json";
import localConfig from "./config.local.json";
import { Config } from "./config.types";

const envConfigs: Record<string, Config> = {
    test: { ...baseConfig, ...devConfig },
    development: { ...baseConfig, ...devConfig },
    production: { ...baseConfig, ...prodConfig },
    staging: { ...baseConfig, ...stagingConfig },
    local: { ...baseConfig, ...localConfig },
};

const envKey = (process.env.REACT_APP_CONFIG_ENV || process.env.NODE_ENV)?.trim();
console.info(`Using config for ${envKey} environment`)
const envCognitoPoolId = process.env.REACT_APP_COGNITO_POOL_ID;
const envCognitoAppClientId = process.env.REACT_APP_COGNITO_APP_CLIENT_ID;

// TypeScript: `process.env.*` puede venir como `undefined`. El runtime debe seguir
// fallando si no existe un env válido.
if (!envKey || !(envKey in envConfigs)) throw new Error(`${envKey} is not a valid env config`);

const config = envConfigs[envKey];

config.contentfulApiKey = process.env.REACT_APP_CONTENTFUL_API_KEY;
config.cognito = {
    poolId: envCognitoPoolId?.trim() ?? "",
    appClientId: envCognitoAppClientId?.trim() ?? "",
};

export default config;
